import { Theme } from '@mui/material/styles';

export const getMuiCssBaseline = (theme: Theme): Record<string, unknown> => ({
  MuiCssBaseline: {
    styleOverrides: {
      '*': {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
      },

      html: {
        fontSize: `${theme.typography.fontSize}px !important`,
      },

      a: {
        color: 'inherit',
      },

      body: {
        color: 'inherit',
        margin: 0,
        padding: 0,
      },

      button: {
        minHeight: 'unset',
      },

      '#elixir body': {
        backgroundColor: theme.palette.common.white,
        fontSize: theme.typography.fontSize,
      },

      'ul li': {
        listStyleType: 'none',
      },

      '.fd-dialog h3': {
        color: 'unset',
      },
      '.fd-autocomplete__dropdown': {
        zIndex: theme.zIndex.modal,
      },

      '.fd-cc-modal__heading': {
        color: theme.palette.text.primary,
      },
      '.fd-cc-modal__text': {
        color: theme.palette.text.primary,
      },
      '.fd-cc-modal__text_link': {
        color: theme.palette.text.primary,
      },
      '.fd-cc-manage-btn': {
        color: theme.palette.text.primary,
      },

      '#flipdish-budapest': {
        backgroundColor: theme.palette.common.white,
        fontSize: theme.typography.fontSize,
      },

      '#elixir #flipdish-budapest': {
        paddingTop: '60px',
      },

      '#elixir #menu1.section': {
        all: 'unset',
      },
      '#elixir #menu1.section h2, #elixir .fd-dialog h2': {
        color: 'unset',
      },
      '#elixir #menu1.section.dark': {
        background: 'unset',
      },
      '#elixir #menu1.section.dark h2': {
        color: 'unset',
      },
      '#elixir #menu1.section.dark input[type="text"]': {
        all: 'unset',
      },
      '#elixir #menu1.section.dark input[type="email"]': {
        all: 'unset',
      },
      '#elixir #menu1.section.dark textarea': {
        all: 'unset',
      },

      '#elixir #menu1 .container': {
        all: 'unset',
        marginBottom: 'unset',
        textAlign: 'unset',
        width: '100%',
      },
      '#elixir #menu1 .container.no-margin': {
        all: 'unset',
      },
      '#elixir #menu1 .container .row': {
        all: 'unset',
        width: '100%',
      },

      '#elixir #flipdish-budapest h2': {
        color: 'unset',
      },
      '#elixir #flipdish-budapest h3': {
        color: 'revert',
      },
      '#elixir #flipdish-budapest a:hover': {
        color: 'unset',
      },
      '#elixir #flipdish-budapest ul': {
        lineHeight: 'unset',
        listStyleType: 'none',
      },
      '#elixir #flipdish-budapest label': {
        marginBottom: 0,
      },
      '#elixir #flipdish-budapest input': {
        color: 'unset',
        marginBottom: '0',
      },
      '#elixir #flipdish-budapest textarea': {
        color: 'unset',
        marginBottom: '0',
        minHeight: 'unset',
      },
      '#elixir textarea:focus': {
        boxShadow: 'none',
        borderColor: 'transparent',
        outline: '0 none',
      },
      '#elixir input:focus': {
        boxShadow: 'none',
        borderColor: 'transparent',
        outline: '0 none',
      },
      '#elixir input[type]:focus': {
        boxShadow: 'none',
        borderColor: 'transparent',
        outline: '0 none',
      },
      '#elixir .uneditable-input:focus': {
        boxShadow: 'none',
        borderColor: 'transparent',
        outline: '0 none',
      },

      [`@media (max-width: 599px)`]: {
        '#elixir #flipdish-budapest': {
          paddingTop: '0px',
        },
      },

      [`@media (max-width: 767px)`]: {
        '#elixir #menu1.section': {
          textAlign: 'unset',
        },

        '#elixir #menu1 .container': {
          all: 'unset',
        },
      },

      [`@media (min-width: 768px)`]: {
        '#elixir #menu1.section': {
          textAlign: 'unset',
        },

        '#elixir #menu1 .container': {
          all: 'unset',
        },
      },

      [`@media (max-width: 990px)`]: {
        '#elixir #menu1.section': {
          textAlign: 'unset',
        },

        '#elixir #menu1 .container': {
          all: 'unset',
        },
      },

      [`@media (max-width: 1024px)`]: {
        '#elixir #menu1.section': {
          textAlign: 'unset',
        },

        '#elixir #menu1 .container': {
          all: 'unset',
        },

        '#flipdish-budapest article': {
          margin: 'unset',
          maxWidth: 'unset',
        },
      },
    },
  },
});
